import { isInteger } from 'lodash';

function safeParse(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function setLastWorkspaceId(email, workspaceId) {
  let lastWorkspaces = safeParse('lastWorkspaceId') || [];
  lastWorkspaces = lastWorkspaces.filter((item) => item.email !== email);
  lastWorkspaces.push({ email, workspaceId });
  localStorage.setItem('lastWorkspaceId', JSON.stringify(lastWorkspaces));
}

export function getLastActiveWorkspaceId() {
  const lastWorkspaces = safeParse('lastWorkspaceId');
  if (!lastWorkspaces?.length) return null;
  const lastEntry = lastWorkspaces[lastWorkspaces.length - 1];
  return lastEntry?.workspaceId ? parseInt(lastEntry.workspaceId, 10) : null;
}

export function getLastWorkspaceId(email) {
  if (isInteger(safeParse('lastWorkspaceId'))) localStorage.removeItem('lastWorkspaceId');
  const lastWorkspaces = safeParse('lastWorkspaceId');
  let workspaceId = null;
  if (lastWorkspaces?.length) {
    workspaceId = lastWorkspaces?.find((historyItem) => historyItem?.email === email)?.workspaceId;
  }
  return workspaceId ? parseInt(workspaceId, 10) : null;
}
